import React from 'react';
import classNames from 'classnames';
import { TooltipColor } from './enums/TooltipColor';
import { TooltipPosition } from './enums/TooltipPosition';
import classes from './Tooltip.module.scss';

interface IProps {
    color?: TooltipColor;
    isSmall?: boolean;
    className?: string;
    position?: TooltipPosition;
    onClick?(): void;
}

const defaultProps: Partial<IProps> = {
    position: TooltipPosition.TOP,
};

export const Tooltip: React.FC<React.PropsWithChildren<IProps>> = (props) => (
    <div
        className={classNames(
            classes.container,
            classes[props.color],
            { [classes.small]: props.isSmall },
            classes[props.position],
            props.className,
        )}
        role="presentation"
        onClick={props.onClick}
    >
        {props.children}
    </div>
);

Tooltip.defaultProps = defaultProps;
